import {EvaluatorNotificationList} from "./EvaluatorNotificationList";
import {EvaluatorNotificationEdit} from "./EvaluatorNotificationEdit";
import {EvaluatorNotificationCreate} from "./EvaluatorNotificationCreate";

export default {
    list: EvaluatorNotificationList,
    create: EvaluatorNotificationCreate,
    edit: EvaluatorNotificationEdit
};
